const ETERNAL_BRANDING_NAMES = new Set([
  'eternal',
  'eternal applications',
  'eternal applications, inc.',
  'eternal applications inc.'
]);

export const isEternalOnlyBranding = (companyName?: string | null): boolean => {
  const normalizedName = companyName?.trim().toLowerCase();

  if (!normalizedName) {
    return false;
  }

  return ETERNAL_BRANDING_NAMES.has(normalizedName);
};

export const toAlphaColor = (hexColor: string, alpha: number) => {
  const normalizedHex = hexColor.replace('#', '');
  const expandedHex =
    normalizedHex.length === 3
      ? normalizedHex
          .split('')
          .map((char) => `${char}${char}`)
          .join('')
      : normalizedHex;

  if (!/^[0-9a-fA-F]{6}$/.test(expandedHex)) {
    return `rgba(84, 73, 220, ${alpha})`;
  }

  const red = parseInt(expandedHex.slice(0, 2), 16);
  const green = parseInt(expandedHex.slice(2, 4), 16);
  const blue = parseInt(expandedHex.slice(4, 6), 16);

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};
